import { createFileRoute, useParams } from '@tanstack/react-router';

import { WorkspaceEngagementResourceDetailScreen } from '@/features/engagement-resources/components/WorkspaceEngagementResourceDetailScreen';

export const Route = createFileRoute('/_staff/admin/workspace/engagement/resources/$id/')({
  component: WorkspaceEngagementResourceDetailRoute,
});

function WorkspaceEngagementResourceDetailRoute() {
  const { id } = useParams({ from: '/_staff/admin/workspace/engagement/resources/$id/' });
  return <WorkspaceEngagementResourceDetailScreen id={id} surface="workspace" />;
}
